/* Mezuzah Store: LA store status and the chat button (HELP-STRIP-V48, CTO relay 2026-10-27-1230).
   One calculation for the footer help strip (sections/mezuzah-help-strip.liquid) and the Store Hours card
   (snippets/mezuzah-visit-us.liquid). It reads the attributes snippets/mezuzah-store-hours-attrs.liquid
   prints from Theme settings > Store info: the week, the closed dates and every status word. Day names and
   times are formatted by Intl in the store's language (data-store-locale, Shopify's request.locale); no word is
   typed here. The clock is the store's (America/Los_Angeles), never the shopper's. */
(function () {
  if (window.mzStoreHours) return;

  var TZ = 'America/Los_Angeles';
  var KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  function parseHour(v) {
    var m = /^\s*(\d{1,2}):(\d{2})\s*$/.exec(v || '');
    if (!m) return null;
    var h = parseInt(m[1], 10), mi = parseInt(m[2], 10);
    return h <= 23 && mi <= 59 ? h + mi / 60 : null;
  }
  function fmtTime(h, loc) {
    var hh = Math.floor(h), mm = Math.round((h - hh) * 60);
    var d = new Date(Date.UTC(2023, 0, 1, hh, mm));
    var o = mm ? { hour: 'numeric', minute: '2-digit', timeZone: 'UTC' } : { hour: 'numeric', timeZone: 'UTC' };
    return new Intl.DateTimeFormat(loc, o).format(d);
  }
  // 2023-01-01 was a Sunday, so day i of that week has index i in KEYS.
  function dayName(i, style, loc) {
    return new Intl.DateTimeFormat(loc, { weekday: style, timeZone: 'UTC' }).format(new Date(Date.UTC(2023, 0, 1 + i)));
  }
  function fill(t, v) {
    var out = String(t || '');
    Object.keys(v).forEach(function (k) { out = out.split('[' + k + ']').join(v[k]); });
    return out;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  // Today in the store's zone: its date, weekday index and hour of day.
  function storeNow() {
    var o = {};
    new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    var y = +o.year, m = +o.month, d = +o.day;
    return { y: y, m: m, d: d, wd: new Date(Date.UTC(y, m - 1, d)).getUTCDay(), h: (+o.hour % 24) + (+o.minute) / 60 };
  }
  function shift(n, days) {
    var t = new Date(Date.UTC(n.y, n.m - 1, n.d + days));
    return { ymd: t.getUTCFullYear() + '-' + pad(t.getUTCMonth() + 1) + '-' + pad(t.getUTCDate()), wd: t.getUTCDay() };
  }
  function read(root) {
    var words = {};
    try { words = JSON.parse(root.getAttribute('data-store-words') || '{}'); } catch (e) {}
    return {
      week: KEYS.map(function (k) {
        var o = parseHour(root.getAttribute('data-hours-' + k + '-open'));
        var c = parseHour(root.getAttribute('data-hours-' + k + '-close'));
        return o == null || c == null || c <= o ? null : { o: o, c: c };
      }),
      closed: (root.getAttribute('data-closed-dates') || '').split(',').filter(Boolean),
      words: words,
      locale: root.getAttribute('data-store-locale') || undefined
    };
  }
  function hoursOn(info, day) {
    return info.closed.indexOf(day.ymd) !== -1 ? null : info.week[day.wd];
  }

  // { open, chip, note, todayWd, todayClosedDate, info } for the element that carries the attributes.
  function status(root) {
    var info = read(root), w = info.words, loc = info.locale, n = storeNow(), today0 = shift(n, 0);
    var today = hoursOn(info, today0);
    var open = !!today && n.h >= today.o && n.h < today.c;
    var next = null;
    if (!open) {
      // The chip is Title Case and the card note is a sentence, so each has its own today and tomorrow words.
      if (today && n.h < today.o) next = { day: w.today, chipDay: w.todayChip, o: today.o, offset: 0 };
      else {
        for (var i = 1; i <= 14 && !next; i++) {
          var day = shift(n, i), hrs = hoursOn(info, day);
          if (hrs) next = { day: i === 1 ? w.tomorrow : dayName(day.wd, 'long', loc), chipDay: i === 1 ? w.tomorrowChip : dayName(day.wd, 'long', loc), o: hrs.o, offset: i };
        }
      }
    }
    var chip, note = '';
    if (open) {
      chip = w.open;
      note = fill(w.openUntil, { time: fmtTime(today.c, loc) });
    } else if (next) {
      chip = fill(w.closedOpens, { day: next.chipDay, time: fmtTime(next.o, loc) });
      note = next.offset === 0 ? fill(w.opensToday, { time: fmtTime(next.o, loc) }) : fill(w.opensOther, { day: next.day, time: fmtTime(next.o, loc) });
    } else {
      chip = w.closed;
    }
    return { open: open, chip: chip, note: note, hasNext: !!next, todayWd: n.wd, todayClosedDate: info.closed.indexOf(today0.ymd) !== -1, info: info };
  }

  function renderStrip(root) {
    var s = status(root);
    var chip = root.querySelector('[data-mzhs-chip]');
    if (!chip) return;
    chip.textContent = s.chip;
    chip.classList.toggle('mzhs__chip--open', s.open);
    chip.classList.toggle('mzhs__chip--closed', !s.open);
    chip.hidden = !s.chip;
  }
  function renderAllStrips() {
    document.querySelectorAll('[data-mzhs]').forEach(renderStrip);
  }

  // Chat buttons: with Store info > Chat button opens = Shopify Inbox, a tap opens the Shopify Inbox chat
  // (<shopify-chat>, from the Shopify Inbox app embed) with its show() method, the same call the service status
  // page's ?chat=1 uses, and its open property when it has one. When that element is missing or not ready, or
  // the setting is WhatsApp, the link's own WhatsApp address runs.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mz-chat="inbox"]');
    if (!btn) return;
    var chat = document.querySelector('shopify-chat');
    if (!chat || !window.customElements || !customElements.get('shopify-chat')) return;
    var canShow = typeof chat.show === 'function';
    var canOpen = 'open' in chat;
    if (!canShow && !canOpen) return;
    e.preventDefault();
    if (canShow) chat.show();
    if (canOpen) chat.open = true;
  });

  window.mzStoreHours = { status: status, dayName: dayName, fmtTime: fmtTime, fill: fill, renderStrip: renderStrip };
  // Anything that rendered before this file ran (a Store Hours card, or a section the theme editor added later)
  // waits for this event instead of a page event that may already have passed.
  document.dispatchEvent(new CustomEvent('mz:store-info:ready'));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAllStrips);
  else renderAllStrips();
  // The chip follows the clock: redraw each minute while the page is visible, and when it comes back.
  setInterval(function () { if (!document.hidden) renderAllStrips(); }, 60000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) renderAllStrips(); });
  document.addEventListener('shopify:section:load', renderAllStrips);
})();
